import React, { useState } from 'react';
import { Accordion } from './Accordion';
const faqs = [{
  q: '¿Sirve si recién empiezo a dar clases de música?',
  a: 'Sí. El repertorio está armado para usar tal cual, sin necesidad de años de experiencia frente al curso.'
}, {
  q: '¿Tengo que adaptar las partituras o ya están listas?',
  a: 'Ya están listas para usar. También incluyen indicación de nivel y digitación simplificada por si necesitás adaptarlas.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Acceso inmediato después del pago. Digital — celular, tablet o computadora. También podés imprimirlo.'
}, {
  q: '¿Qué diferencia hay entre los dos planes?',
  a: 'El Sistema Base tiene los 6 tomos y 4 bonos — ideal para nunca más armar un acto a las apuradas. El Plan PRO agrega arreglos a 2 voces, backing tracks y planificación NAP con certificados.'
}, {
  q: '¿Sirve para cualquier nivel de primaria?',
  a: 'Sí. El Tomo 6 incluye progresión desde 1er grado, y el resto del repertorio está clasificado por nivel de dificultad.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días, sin preguntas. Te devolvemos el 100%. Menos del 1% pide devolución.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-navy text-white py-12" data-id="element-45">
      <div className="max-w-md mx-auto px-4" data-id="element-46">
        <h2 className="text-2xl font-bold text-center mb-8" data-id="element-47">
          Lo que más nos preguntan
        </h2>

        <div className="space-y-3" data-id="element-48">
          {faqs.map((faq, idx) => <Accordion key={idx} isOpen={openIndex === idx} onToggle={() => setOpenIndex(openIndex === idx ? null : idx)} title={<span className="text-[15px] font-medium" data-id="element-50">{faq.q}</span>} className="bg-navy-light border border-white/5" headerClassName="hover:bg-white/5" data-id="element-49">
              <p className="text-sm text-gray-light leading-relaxed pt-2 pb-2" data-id="element-51">
                {faq.a}
              </p>
            </Accordion>)}
        </div>
      </div>
    </section>;
}